import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const InvoiceDetailHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Invoice Detail</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default InvoiceDetailHeader;
